<template>
  <div>
    <SidebarTab :items="lastMenuItems" v-if="selected === 'more'" @selected="goToSelectedPath" />
    <div class="menu-container">
      <button
        v-for="item in firstMenuItems"
        :key="item.name"
        class="item tw-text-gray-600"
        :class="{ selected: selected === item.name }"
        @click="goToSelectedPath(item)"
      >
        <div class="icon-wrapper hover:tw-bg-gray-100" :class="{ '!tw-bg-pool-blue-50': selected === item.name }">
          <AppIcon
            :class="[
              { 'tw-fill-gray-600 hover:tw-fill-gray-600': selected !== item.name },
              { 'tw-fill-blue-500': selected === item.name },
            ]"
            :icon="item.icon"
          />
        </div>
        <span class="font-size-9" :class="{ 'tw-text-blue-500': selected === item.name }">{{ item.title }}</span>
      </button>
      <button class="item tw-text-gray-600" :class="{ selected: selected === 'more' }" @click="switchMoreButton">
        <div class="icon-wrapper hover:tw-bg-gray-100" :class="{ '!tw-bg-pool-blue-50': selected === 'more' }">
          <AppIcon
            :class="[
              { 'tw-fill-gray-600 hover:tw-fill-gray-600': selected !== 'more' },
              { 'tw-fill-blue-500': selected && selected === 'more' },
            ]"
            icon="menu"
          />
        </div>

        <span class="font-size-9" :class="{ 'tw-text-blue-500': selected === 'more' }">Mais</span>
      </button>
    </div>
  </div>
</template>
<script>
import { useUtil } from '@/plugins/util'
import { routes } from '@/router/routes'
import { useAuthStore, UserType } from '@/store/pinia/auth'
import { usePhysicianStore } from '@/store/pinia/physician'
import AppIcon from '@/v2/components/ui/icon/AppIcon.vue'
import SidebarTab from './SidebarTab.vue'
import { useV2Api } from '@/plugins/api/openapi'
import * as amplitude from '@amplitude/analytics-browser'

export default {
  name: 'MobileMenuDrawer',
  components: {
    AppIcon,
    SidebarTab,
  },
  computed: {
    firstMenuItems() {
      const items = this.items

      return [...items].splice(0, 4)
    },
    lastMenuItems() {
      const items = this.items

      return [...items].splice(4, items.length)
    },
    parameterFilteredRoutes() {
      return routes
    },
    userType() {
      return UserType
    },
    extensionRoutes() {
      return this.physicianStore.extensionSubscriptions.flatMap(
        (subscription) => subscription.extension?.additionalRoutes ?? [],
      )
    },
  },
  data() {
    return {
      items: [],
      projects: [],
      selected: null,
      selectedModal: null,
      modal: false,
      showTooltips: false,
      loadedData: false,
      sumScreenings: 0,
    }
  },
  watch: {
    '$route.name': {
      handler(val) {
        this.selected = this.items.find((item) => item.name == val || item.name === this.$route.meta?.parent)?.name
      },
    },
    extensionRoutes: {
      handler(val) {
        this.menuItems()
      },
    },
  },
  methods: {
    goToSelectedPath(item) {
      const util = useUtil()
      const physicianStore = usePhysicianStore()

      const userData = util.prepareAnalyticsUserProperties(physicianStore)
      amplitude.track('Clique em botão no menu', {
        button: item.name,
        buttonTitle: item.title,
        ...userData,
      })
      this.selected = item.name
      this.$router.push({ name: item.name })
    },
    routesFromParameters() {
      let items = this.parameterFilteredRoutes
        .filter((route) => !route.meta?.admin)
        .filter(
          (route) => (route.name === 'screening' && this.authStore.userHasScreenings) || route.name !== 'screening',
        )
        .filter((route) => !route.meta?.hidden && !route.meta?.singlePage)
        .map((route) => ({
          path: route.path,
          name: route.name,
          title: route.meta?.title,
          icon: route.meta?.icon,
          tooltip: route.meta?.tooltip,
        }))

      this.items = items
    },
    menuItems() {
      let items = []

      if (this.authStore.userType !== this.userType.ADMIN && this.parameterFilteredRoutes.length > 0) {
        this.routesFromParameters()
        return
      }

      items = this.parameterFilteredRoutes
        .filter((route) => route.path !== '/' && !route.meta?.hidden)
        .filter(
          (route) => route.meta?.public || (this.authStore.userType === this.userType.ADMIN && !route.meta?.hideAdmin),
        )
        .map((route) => ({
          path: route.path,
          name: route.name,
          title: route.meta?.title,
          icon: route.meta?.icon,
        }))

      this.items = items

      return
    },
    openModal(item) {
      this.selectedModal = item.selected
      this.projects = item.projects
      this.modal = true
    },
    switchMoreButton() {
      this.selected =
        this.selected === 'more'
          ? this.items.find((item) => item.name == this.$route.name || item.name === this.$route.meta?.parent)?.name
          : 'more'
    },
  },
  setup() {
    const authStore = useAuthStore()
    const api = useV2Api()
    const physicianStore = usePhysicianStore()

    return {
      api,
      authStore,
      physicianStore,
    }
  },
  mounted() {
    this.menuItems()
    this.selected = this.items.find(
      (item) => item.name == this.$route.name || item.name === this.$route.meta?.parent,
    )?.name
  },
}
</script>
<style scoped>
.menu-container {
  padding: 12px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 67px;
  max-height: 67px;
  z-index: 20;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}

.menu-container .item {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.menu-container .item .icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
